export default __webpack_public_path__ + "caaac285185979db75745078216947b6.png";